export default __webpack_public_path__ + "static/media/dummy_thumb_4.4081a531.png";